export const WORKING_MINUTES = 5;
export const LOGGED_MINUTES = 15;
